import { l10n } from '@ott/l10n';

const CODES = {
  WRONG_PASSPORT_TYPE: 'WRONG_PASSPORT_TYPE',
  UNSUPPORTED_IMAGE_FORMAT: 'UNSUPPORTED_IMAGE_FORMAT',
};

export const getErrorByCode = (err: string) => {
  let error = '';

  switch (err) {
    case CODES.WRONG_PASSPORT_TYPE: {
      error = l10n('virtualCard.passportRecognition.error.wrongPassportType');
      break;
    }
    case CODES.UNSUPPORTED_IMAGE_FORMAT: {
      error = l10n('virtualCard.passportRecognition.error.unsupportedImageFormat');
      break;
    }
    default: {
      error = l10n('virtualCard.passportRecognition.error.default');
      break;
    }
  }

  return error;
};
